import { render, staticRenderFns } from "./AsuntoVista.vue?vue&type=template&id=793ba1c3&scoped=true&"
import script from "./AsuntoVista.vue?vue&type=script&lang=js&"
export * from "./AsuntoVista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ba1c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
